import { useEffect, useState } from "react";

function useHaveScoll(callback?: any, dependency = []) {
  const [haveScrolled, sethaveScrolled] = useState(false);

  useEffect(() => {
    function toggleScroll() {
      if (process.browser) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > 0) {
          sethaveScrolled(true);
          window.removeEventListener("scroll", callback || toggleScroll);
        }
      }
    }
    window.addEventListener("scroll", callback || toggleScroll);
    return () => {
      window.removeEventListener("scroll", callback || toggleScroll);
    };
  }, dependency);

  return [haveScrolled];
}

export default useHaveScoll;
